<button
  type="button"
  class="option-card"
  [class.option-card--selected]="selected"
  [class.option-card--disabled]="disabled"
  [disabled]="disabled"
  [attr.aria-pressed]="selected"
  (click)="onSelect()"
>
  <span class="option-card__leading">
    <ds-icon
      *ngIf="icon"
      class="option-card__icon"
      [icon]="icon"
      width="20px"
      height="20px"
    ></ds-icon>
    <span class="option-card__content">
      <span class="option-card__title">{{ label }}</span>
      <span class="option-card__description" *ngIf="description">{{ description }}</span>
    </span>
  </span>
  <span class="option-card__radio" [class.option-card__radio--checked]="selected" aria-hidden="true"></span>
</button>
